import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, ArrowRight, Feather } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const HomeFeatures: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section id="features-section" className="py-24 bg-maat-stone border-t border-maat-sand">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-serif text-maat-blue mb-6 text-center leading-tight">
            {t.aiSection.title}
          </h2>
          <div className="text-base md:text-lg font-light text-maat-blue/80 leading-relaxed mb-12 text-center">
            <p>{t.aiSection.intro}</p>
          </div>

          <div className="flex justify-center items-center mb-12">
            <div className="w-16 h-px bg-maat-sand/60"></div>
            <Feather className="mx-4 text-maat-gold/60" size={32} strokeWidth={1.5} />
            <div className="w-16 h-px bg-maat-sand/60"></div>
          </div>
          
          <div className="mb-12">
            <h3 className="text-xl md:text-2xl font-serif text-maat-blue text-center mb-8">
              {t.homeFeatures.title}
            </h3>
            <div className="space-y-4 max-w-3xl mx-auto">
              {t.homeFeatures.points.map((point, index) => (
              <div key={index} className="flex items-start space-x-4 bg-white/40 p-5 rounded-3xl border border-white/60 shadow-sm">
                <CheckCircle2 className="text-maat-gold flex-shrink-0 mt-0.5" size={24} strokeWidth={2} />
                <p className="text-base md:text-lg text-maat-blue/90 leading-relaxed font-light">
                  {point}
                </p>
              </div>
            ))}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/methodology" className="bg-maat-blue text-maat-stone px-8 py-4 rounded-3xl font-bold hover:bg-opacity-90 transition-all duration-300 w-full sm:w-auto text-center shadow-lg transform hover:-translate-y-1 flex items-center justify-center">
              {t.nav.methodology}
            </Link>
            <Link to="/services" className="bg-maat-blue text-maat-stone px-8 py-4 rounded-3xl font-bold hover:bg-opacity-90 transition-all duration-300 w-full sm:w-auto text-center shadow-lg transform hover:-translate-y-1 flex items-center justify-center">
              {t.nav.services}
            </Link>
            <Link to="/contact" className="bg-maat-gold text-maat-blue px-8 py-4 rounded-3xl font-bold hover:bg-opacity-90 transition-all duration-300 w-full sm:w-auto text-center shadow-lg transform hover:-translate-y-1 flex items-center justify-center space-x-2">
              <span>{t.nav.contact}</span>
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeFeatures;
